import { TravelDates } from '../../module/shared-member/organism/listing/shared/travel-dates'

export class ListingViewTracker {
    private views = new Map<string, number>();
    private readonly EXPIRY_MS = 10000; // 10 seconds

    private getKey(listingId: string | null, dates: TravelDates | undefined): string {
        const checkin = dates?.checkin?.toISOString() || 'no-checkin';
        const checkout = dates?.checkout?.toISOString() || 'no-checkout';
        return `${listingId}-${checkin}-${checkout}`;
    }

    hasLogged(listingId: string | null, dates: TravelDates | undefined): boolean {
        const key = this.getKey(listingId, dates);
        const timestamp = this.views.get(key);
        if (!timestamp) return false;
        
        const now = Date.now();
        if (now - timestamp > this.EXPIRY_MS) {
            this.views.delete(key);
            return false;
        }
        return true;
    }

    markLogged(listingId: string | null, dates: TravelDates | undefined) {
        const key = this.getKey(listingId, dates);
        this.views.set(key, Date.now());
    }

    reset() {
        this.views.clear();
    }
}